import GridLoader from 'react-spinners/GridLoader'

import './Loading.scss'

function Loading() {
  return (
    <div className='loading-container'>
      <GridLoader className='spinner' />
    </div>
  )
}

export default Loading
